import React from 'react';
import '../styling/menus.css';

const Card = ({ title, subtitle, icon, onClick, cardClass }) => (
  <button className={`menu-card ${cardClass || ''}`} onClick={onClick}>
    <div className="menu-icon" aria-hidden>{icon}</div>
    <div className="menu-title">{title}</div>
    {subtitle && <div className="menu-subtitle">{subtitle}</div>}
  </button>
);

const OperationsMenu = ({ goBack, toOutcomes, toSettings, logout, onSelect }) => {
  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Equipment Malfunction Report</h1>
      <p className="menu-sub">Select the type of equipment that malfunctioned</p>
      <div className="menu-grid three-cols">
        <Card title="Surgical Equipment" subtitle="Handpieces, surgical instruments, and procedure-specific tools" icon="⚙️" onClick={() => onSelect('Equipment - Surgical')} cardClass="equipment" />
        <Card title="Imaging Equipment" subtitle="X-ray machines, panoramic units, and imaging systems" icon="📷" onClick={() => onSelect('Equipment - Imaging')} cardClass="equipment" />
        <Card title="Sterilization Equipment" subtitle="Autoclaves, sterilizers, and infection control equipment" icon="🛡️" onClick={() => onSelect('Equipment - Sterilization')} cardClass="equipment" />
        <Card title="Anesthesia Equipment" subtitle="Sedation monitors, gas delivery systems, and monitoring devices" icon="👤" onClick={() => onSelect('Equipment - Anesthesia')} cardClass="equipment" />
        <Card title="Computer/Software Systems" subtitle="Practice management software, computers, and digital systems" icon="💻" onClick={() => onSelect('Equipment - Computer/Software')} cardClass="equipment" />
        <Card title="Facility Systems" subtitle="HVAC, lighting, plumbing, and building infrastructure" icon="🏢" onClick={() => onSelect('Equipment - Facility Systems')} cardClass="equipment" />
      </div>
    </div>
  );
};

export default OperationsMenu;


